import { faEthereum } from '@fortawesome/free-brands-svg-icons';
import { faEur, faGbp, faUsd } from '@fortawesome/pro-solid-svg-icons';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import {
  FiatCurrency,
  MonetaryAmount,
} from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { MonetaryAmountFiatCurrency } from '@sorare/core/src/lib/monetaryAmount';
import { RoundingMode } from '@sorare/core/src/lib/wei';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--intermediate-unit);
`;
const Group = styled(Horizontal)`
  background: var(--c-nd-100);
  border-radius: var(--intermediate-unit);
  padding: var(--intermediate-unit);
`;

export type Props = {
  wei: bigint;
  fiat: MonetaryAmount | null;
};

export const MonetaryRewards = ({ wei, fiat }: Props) => {
  const { formatWei } = useIntlContext();

  const fiatCurrency = fiat?.referenceCurrency
    ? FiatCurrency[fiat.referenceCurrency.toUpperCase() as FiatCurrency]
    : FiatCurrency.EUR;
  const fiatIcon = {
    [FiatCurrency.USD]: faUsd,
    [FiatCurrency.EUR]: faEur,
    [FiatCurrency.GBP]: faGbp,
  }[fiatCurrency];

  return (
    <Grid>
      <Group>
        <FontAwesomeIcon icon={fiatIcon} />
        <BodyS>
          <FormattedNumber
            value={
              (fiat?.[
                fiat.referenceCurrency.toLowerCase() as MonetaryAmountFiatCurrency
              ] || 0) / 100
            }
            style="currency"
          />
        </BodyS>
      </Group>
      <Group>
        <FontAwesomeIcon icon={faEthereum} />
        <BodyS>
          {formatWei(wei, RoundingMode.ROUND_DOWN, {}, { hideSymbol: true })}
        </BodyS>
      </Group>
    </Grid>
  );
};
